export const InvestmentObjectivesContent = {
  header: 'Now tell us your investing style',
};
